var _path;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
var SvgUser = function SvgUser(props) {
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    width: 32,
    height: 32,
    fill: "currentColor"
  }, props), _path || (_path = /*#__PURE__*/React.createElement("path", {
    fill: "#061e21",
    d: "M16.667 16.667a5.667 5.667 0 1 0 0-11.334 5.667 5.667 0 0 0 0 11.334M20.444 11a3.778 3.778 0 1 1-7.555 0 3.778 3.778 0 0 1 7.555 0M28 26.11C28 28 26.111 28 26.111 28H7.222s-1.889 0-1.889-1.889 1.89-7.556 11.334-7.556S28 24.222 28 26.112m-1.889-.008c-.002-.464-.29-1.862-1.572-3.143-1.231-1.231-3.549-2.516-7.872-2.516-4.326 0-6.642 1.285-7.873 2.516-1.28 1.281-1.568 2.679-1.572 3.143z"
  })));
};
export default SvgUser;